//import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';
import './App.css';

import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import Study from './pages/StudyPage';
import LoginPage from './pages/LoginPage';
import ProfilePage from './pages/ProfilePage';
import AdminPage from './pages/AdminPage';
import FeedbackTab from './pages/admin/FeedbackTab';
import CostsTab from './pages/admin/CostsTab';
import UsersTab from './pages/admin/UsersTab';
import ActivityTab from './pages/admin/ActivityTab';
import TopicsTab from './pages/admin/TopicsTab';
import QuestionsTab from './pages/admin/QuestionsTab';
import PrivacyPage from './pages/PrivacyPage';
import FaqPage from './pages/FaqPage';
import NavBarThing from './NavBar';
import FeedbackButton from './components/FeedbackButton';
import { RolesProvider } from './context/RolesContext';

function App() {
  const isAuthenticated = useIsAuthenticated();
  const { inProgress } = useMsal();
  const authLoading = inProgress !== InteractionStatus.None;

  return (
    <Router>
      <RolesProvider>

        <div className="App">
          <NavBarThing />

          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/study" element={authLoading ? null : (isAuthenticated ? <Study /> : <Navigate to="/login" replace />)} />
            <Route path="/login" element={authLoading ? null : (isAuthenticated ? <Navigate to="/study" replace /> : <LoginPage />)} />
            <Route path="/profile" element={authLoading ? null : (isAuthenticated ? <ProfilePage /> : <Navigate to="/login" replace />)} />
            <Route path="/admin" element={authLoading ? null : (isAuthenticated ? <AdminPage /> : <Navigate to="/login" replace />)}>
              <Route index element={<Navigate to="feedback" replace />} />
              <Route path="feedback" element={<FeedbackTab />} />
              <Route path="costs" element={<CostsTab />} />
              <Route path="users" element={<UsersTab />} />
              <Route path="activity" element={<ActivityTab />} />
              <Route path="topics" element={<TopicsTab />} />
              <Route path="questions" element={<QuestionsTab />} />
            </Route>
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/faq" element={<FaqPage />} />
          </Routes>

          <FeedbackButton />
        </div>

      </RolesProvider>
    </Router>
  );
}

export default App;